import PropTypes from 'prop-types'

const SkillSection = ({ items, title }) => (

    <div className="page three">
        <p className="text-center" >{title}</p>
        <div className="row">
            {items.map((data, index) => (
                <div key={index} className="col-md-6 animate-box">
                    <div className="progress-wrap ftco-animate fadeInUp ftco-animated">
                        <h3 className="text-skill">{data.title}</h3>
                        <div className="progress">
                            <div
                                className="progress-bar progress-bar-striped progress-bar-animated color-1"
                                role="progressbar"
                                aria-valuenow="95"
                                aria-valuemin="0"
                                aria-valuemax="100"
                                style={{ width: `${data.cant}%` }}
                            >
                                <span>{data.cant}%</span>
                            </div>
                        </div>
                    </div>
                </div>)
            )}
        </div>
    </div>)



SkillSection.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        cant: PropTypes.number,
        title: PropTypes.string,
    })),
    title: PropTypes.string,

}

export default SkillSection
